// src/v3/ui/_common/components/ui/theme-toggle.tsx

import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

const THEME_MODE_OBJ = {
  LIGHT: "light",
  DARK: "dark",
} as const;

export function ThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("theme");
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const dark = stored ? stored === THEME_MODE_OBJ.DARK : prefersDark;
    setIsDark(dark);
    document.documentElement.classList.toggle("dark", dark);
  }, []);

  const toggle = () => {
    const next = !isDark;
    setIsDark(next);
    localStorage.setItem("theme", next ? THEME_MODE_OBJ.DARK : THEME_MODE_OBJ.LIGHT);
    document.documentElement.classList.toggle("dark", next);
  };

  return (
    <button
      onClick={toggle}
      className="rounded-md border p-2 hover:bg-accent"
      aria-label="Toggle theme"
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
